export enum UnitOfDisplay {
    consumption = 'Consumption',
    cost = 'Cost'
}